import React from 'react';
import classNames from 'classnames';

import css from './Toast.module.css';

/**
 * Floating toast notification — bottom-centered, briefly visible, then fades.
 *
 * Push 8 Phase A.4e-1a polish: introduced for the customer-side Documents
 * subsection's "Copied to clipboard" feedback after the share-icon path
 * falls through to the clipboard fallback. Kept generic / reusable; the
 * parent controls visibility by passing/clearing the `message` prop.
 *
 * Usage:
 *   const [toastMessage, setToastMessage] = useState(null);
 *   const showToast = msg => {
 *     setToastMessage(msg);
 *     setTimeout(() => setToastMessage(null), 2500);
 *   };
 *   <Toast message={toastMessage} />
 *
 * The fade-in/hold/fade-out timing is pure CSS (animations on `.toast`).
 * Total visible duration ≈ 2.6s; the parent's 2500ms setTimeout matches
 * that so a follow-up showToast can fire cleanly without clobbering an
 * in-flight animation.
 */
const Toast = ({ message, className, rootClassName }) => {
  if (!message) return null;

  return (
    <div
      className={classNames(rootClassName || css.toast, className)}
      role="status"
      aria-live="polite"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
      <span className={css.message}>{message}</span>
    </div>
  );
};

export default Toast;
